import {
  ICheckoutRules,
  SessionDataArgs,
} from '../graphQL/queries/getSession/types'
import { Localization } from '../interfaces'
import { setCheckoutRules, setSessionData } from '../redux/slices/config'
import { AppDispatch } from '../redux/store'
import { castCheckoutRulesMessages } from './castCheckoutRules'
import getUrlParams from './getUrlParams'

const { language } = getUrlParams(window.location.pathname)

interface IWriteSessionDataArgs {
  session: SessionDataArgs
  dispatch: AppDispatch
  /** `config.options.localization`, the fallback when the URL names no language. */
  localization?: Localization
}

/**
 * Writes a session read into the store: `setSessionData`, which replaces the
 * snapshot and recomputes `config.options.hidePricesActive` from the
 * customer's custom fields, then the checkout-rule messages cast to the
 * language (the URL's, else `localization`, else Spanish), since the
 * snapshot `setSessionData` wrote holds them uncast.
 *
 * Shared by the boot prefetch (`useInitialCatalogData`,
 * `useInitialCategoriesData`) and `refreshCatalog` (COM-1520). It writes the
 * session snapshot and nothing else: the banners and advanced filters boot
 * also takes from the session stay with the boot hooks.
 *
 * Throws what the reducers throw (`setSessionData` reads
 * `checkoutRules.cartConditionPendingMinAmount.isActive` unguarded); a caller
 * that must not fail on a bad session catches it.
 * @internal
 */
export const writeSessionData = ({
  session,
  dispatch,
  localization,
}: IWriteSessionDataArgs): void => {
  dispatch(setSessionData(session))
  const checkoutRules = session.configuration?.checkoutRules
  if (!checkoutRules) {
    return
  }
  const lang = language || localization || Localization.Es
  dispatch(
    setCheckoutRules(
      castCheckoutRulesMessages(checkoutRules, lang) as ICheckoutRules,
    ),
  )
}

export default writeSessionData
